<template>
  <div class="container">
    <div class="main-container">
      <div class="side-left">
        <div></div>
        <div class="side-container">
          <h3 class="title">Thể lệ</h3>
          <div class="label">
            <span class="block mb-6">
              <span class="block mb-3 label-title">1. THỂ LỆ THAM GIA CHƯƠNG TRÌNH</span>
              <span class="block mb-1">- Mỗi khách hàng đăng ký chương trình thành công khi tạo hợp đồng trên web đăng ký học sẽ có 1 Mã học viên riêng.</span>
              <span class="block mb-1">- Mã học viên chính là mã dự thưởng tham gia chương trình QUAY THƯỞNG TRÚNG QUÀ.</span>
              <span class="block mb-1">- Trung tâm tổ chức quay thưởng bằng phần mềm ngẫu nhiên theo lịch đã công bố để xác định khách hàng đoạt giải thưởng.</span>
            </span>
            <span class="block mb-6">
              <span class="block mb-3 label-title">2. QUY TRÌNH THAM GIA QUAY THƯỞNG</span>
              <span class="block mb-3">Bước 1: Khách hàng đăng ký học thành công tại CLASSUP trong thời gian từ ngày 01/09/2026 đến ngày 30/09/2026.</span>
              <span class="block mb-1">Bước 2: TVV hướng dẫn khách hàng kiểm tra Mã học viên của cá nhân trong danh sách quay thưởng được cập nhật trên Fanpage vào ngày 10/10/2026.</span>
              <span class="block mb-3" style="font-style: italic">Lưu ý: Trường hợp khách hàng thuộc diện quay thưởng nhưng không có tên trong danh sách, TVV phản hồi qua TTHT hoặc khách hàng phản hồi trên Fanpage trước 12h00 ngày 11/10/2026 để được cập nhật. Sau thời gian trên, Trung tâm không hỗ trợ xử lý khiếu nại thêm.</span>
              <span class="block mb-3">Bước 3: Khách hàng theo dõi livestream tại Fanpage theo lịch quay thưởng đã công bố.<br>
                Fanpage IELTS MENTOR: <a href="https://www.facebook.com/ieltsmentor.vietnam" target="_blank" rel="noopener" class="figma-link">https://www.facebook.com/ieltsmentor.vietnam</a><br>
                Fanpage CLASSUP: <a href="https://www.facebook.com/ClassUp.vn?locale=vi_VN" target="_blank" rel="noopener" class="figma-link">https://www.facebook.com/ClassUp.vn?locale=vi_VN</a>
              </span>
              <span class="block mb-1">Bước 4: Khách hàng theo dõi điện thoại theo số điện thoại đã đăng ký trên hợp đồng học tập để Trung tâm liên hệ gửi quà.</span>
            </span>
            <span class="block mb-3">
              <span class="block mb-3 label-title">3. CƠ CẤU GIẢI THƯỞNG</span>
              <span class="block mb-1">TỔNG GIÁ TRỊ GIẢI THƯỞNG LÊN ĐẾN 100.000.000Đ</span>
              <span class="block mb-1">- 01 Giải Đặc biệt: 01 Laptop Dell 15 DC15250 KR0N9, trị giá 20.990.000đ.</span>
              <span class="block mb-1">- 02 Giải Nhất: Mỗi giải 01 Máy tính bảng IvyPad Smart 5, trị giá 4.590.000đ.</span>
              <span class="block mb-1">- 10 Giải Nhì: Mỗi giải 01 Đèn thông minh chữ G N69, trị giá 1.390.000đ.</span>
              <span class="block mb-1">- 15 Giải Ba: Mỗi giải 01 Đồng hồ thông minh AMOLED HK85, trị giá 1.080.000đ.</span>
              <span class="block mb-1">- 20 Giải Khuyến khích: Mỗi giải 01 Tai nghe không dây ZTC Air A501, trị giá 790.000đ.</span>
              <span class="block mb-1">- 30 Phần quà may mắn: Mỗi phần quà 01 Set thương hiệu CLASSUP, trị giá 500.000đ.</span>
            </span>
          </div>
        </div>
      </div>
      <div class="middle">
        <!-- <img src="~@/assets/images/sale_program.png" class="sale_program" alt="sale_program"> -->
        <!-- <div class="flex justify-center relative mb-6">
          <img src="~@/assets/images/plane.png" class="plane absolute" alt="plane">
          <div class="button-title">
            LIVESTREAM
          </div>
        </div> -->
        <!-- <div class="title mb-6">
          PHẦN QUÀ
        </div> -->
        <div class="gift-slide relative">
          <!-- <img src="~@/assets/images/percent_left.png" class="percent_left absolute" alt="percent_left"> -->
          <!-- <img src="~@/assets/images/percent_right.png" class="percent_right absolute" alt="percent_right"> -->
          <swiper :slides-per-view="1" navigation :modules="[Navigation]" @slideChange="selectGift($event)">
            <swiper-slide v-for="(gift, index) in gifts" :key="index">
              <img :src="gift.image" class="gift-img" alt="gift-img">
              <span class="block gift-name mb-3">{{ gift.name }}</span>
              <span class="block gift-number">Số lượng quà còn lại: <span class="gift-number__badge">{{ gift.number }}</span></span>
            </swiper-slide>
          </swiper>
        </div>
        <LuckyDraw ref="luckyDraw" @random-user="randomUserCallBack" @gift-success="handleGiftSuccess" :gift_select="gift_select" :result="result_code"
          :maxSpins="6" />
      </div>
      <div class="side-right">
        <div class="side-container">
          <h3 class="title">Lịch sử quay thưởng</h3>
          <div class="mb-3" v-for="(log, index) in logs" :key="index">
            <div class="label mb-3">
              <span>Chúc mừng học viên </span>
              <span class="congrat-yell">{{ log.name }} - </span>
              <span class="congrat-yell">{{ log.code }}</span>
              <span> đã trúng thưởng </span>
              <span class="congrat-yell"> {{ log.gift_name }}</span>
            </div>
            <hr class="divider" />
          </div>
        </div>
        <div></div>
      </div>
    </div>
  </div>
  <div v-if="is_congrat" class="modal-overlay" @click="closeModal">
    <div class="modal-congratulation" @click.stop>
      <span class="block label">Chúc mừng học viên</span>
      <span class="block">{{ congrat_data.name }} - {{ congrat_data.code }}</span>
      <span class="block label">đã trúng thưởng </span>
      <span class="block">{{ congrat_data.gift_name }}</span>
    </div>
  </div>
</template>

<script>
import LuckyDraw from '../components/LuckyDraw.vue'

import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import axios from "axios";

export default {
  name: 'HomeView',
  components: {
    LuckyDraw,
    Swiper,
    SwiperSlide,
  },
  setup() {
    return {
      Navigation
    };
  },
  data() {
    return {
      logs: [],
      gifts: [],
      is_congrat: false,
      gift_select: {},
      congrat_data: '',
      activeIndex: 0,
      result_code: 0
    }
  },
  mounted() {
    this.getRandomUser();
    this.getAllGift();
    this.getAllLogs();
  },
  methods: {
    randomUserCallBack(){
      this.getRandomUser();
    },
    getRandomUser() {
      const apiUrl = process.env.VUE_APP_API_URL;
      axios.get(`${apiUrl}/lucky-draw/users`).then(res => {
        this.result_code = Number(this.getRandomValue(res.data.data));
      });
    },
    getRandomValue(array) {
      const randomIndex = Math.floor(Math.random() * array.length);
      return array[randomIndex];
    },
    getAllLogs() {
      const apiUrl = process.env.VUE_APP_API_URL;
      axios
        .get(`${apiUrl}/lucky-draw`, {
          params: {
            is_export: true
          }
        })
        .then((res) => {
          this.logs = res.data.data;
        });
    },
    selectGift(event) {
      this.activeIndex = event.activeIndex;
      this.gift_select = this.gifts[event.activeIndex];
    },
    closeModal() {
      this.is_congrat = false;
      this.$refs.luckyDraw.confirmDraw();
    },
    async getAllGift() {
      const apiUrl = process.env.VUE_APP_API_URL;
      try {
        const res = await axios.get(`${apiUrl}/lucky-draw/gifts`);
        this.gifts = res.data.data;
        this.gift_select = this.gifts[this.activeIndex];
      } catch (error) {
        console.error("Error fetching gifts:", error);
      }
    },
    startSpinning() {
      this.$refs.luckyDraw.startSpinning();
    },
    async handleGiftSuccess(data) {
      this.is_congrat = true;
      this.congrat_data = data;
      this.getAllLogs();
      await this.getAllGift();
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/custom.scss';
</style>
